import { FC, PropsWithChildren, ReactElement } from 'react'

import './TableBody.scss'

interface TableBodyProps extends PropsWithChildren {
    className?: string;
}

const TableBody: FC<TableBodyProps> = ({
    className = '',
    children,
}): ReactElement => (
    <tbody className={`table-body ${className}`}>
        {children}
    </tbody>
)

export default TableBody
